/**
 * En-tête de la page exercice : retour, titre et boutons Modifier/Annuler/Enregistrer.
 */

import React from 'react';
import { Box, Typography, Button, CircularProgress, IconButton, Alert } from '@mui/material';
import { ArrowBack, Edit, Save, Cancel } from '@mui/icons-material';

interface ExerciseViewHeaderProps {
  isNewMode: boolean;
  isEditMode: boolean;
  saving: boolean;
  exerciseNumber?: number;
  title?: string;
  onBack: () => void;
  onEdit: () => void;
  onCancel: () => void;
  onSave: () => void;
}

/** Barre d'en-tête de la page Détail/Modification d'un exercice. */
export const ExerciseViewHeader: React.FC<ExerciseViewHeaderProps> = ({
  isNewMode, isEditMode, saving, exerciseNumber, title, onBack, onEdit, onCancel, onSave,
}) => (
  <Box display="flex" alignItems="center" mb={3}>
    <IconButton onClick={onBack} sx={{ mr: 2 }}>
      <ArrowBack />
    </IconButton>
    <Typography variant="h4" component="h1" sx={{ flex: 1 }}>
      {isNewMode
        ? 'Nouvel Exercice'
        : (isEditMode
          ? 'Modifier l\'exercice'
          : `Exercice ${exerciseNumber}: ${title}`
        )
      }
    </Typography>

    {!isEditMode && !isNewMode && (
      <Button
        variant="outlined"
        startIcon={<Edit />}
        onClick={onEdit}
      >
        Modifier
      </Button>
    )}

    {isEditMode && (
      <Box>
        <Button
          variant="outlined"
          startIcon={<Cancel />}
          onClick={onCancel}
          sx={{ mr: 1 }}
          disabled={saving}
        >
          Annuler
        </Button>
        <Button
          variant="contained"
          startIcon={saving ? <CircularProgress size={20} /> : <Save />}
          onClick={onSave}
          disabled={saving}
        >
          {saving ? 'Enregistrement...' : 'Enregistrer'}
        </Button>
      </Box>
    )}
  </Box>
);

/** Écran d'erreur avec bouton de retour à la liste des exercices. */
export const ExerciseBackScreen: React.FC<{ message: string; onBack: () => void }> = ({ message, onBack }) => (
  <Box p={3}>
    <Alert severity="error">{message}</Alert>
    <Button startIcon={<ArrowBack />} onClick={onBack} sx={{ mt: 2 }}>
      Retour à la liste
    </Button>
  </Box>
);
